// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"512da8836db1fc10a2af","883":"98a34e0835f5784c77ed"}[chunkId] + ".js";
};